<template>
  <div class="__surequote-complete">
    <h1>Thank you</h1>
    <p class="lead">
      We have received your information and will be in touch shortly.
    </p>

    <p>Please close the window by pressing the button in the top right corner.</p>

    
  </div>
</template>

<script>
export default {
  name: 'complete',
  methods: {

  }
}
</script>
